import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=5debb0f2&scoped=true"
import script from "./validation.vue?vue&type=script&lang=ts"
export * from "./validation.vue?vue&type=script&lang=ts"
import style0 from "./validation.vue?vue&type=style&index=0&id=5debb0f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5debb0f2",
  null
  
)

export default component.exports